import 'slick-carousel/slick/slick'

export default class CaseStudiesSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-case-studies-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                prevArrow: $('.js-cs-slider-previous'),
                nextArrow: $('.js-cs-slider-next'),
                appendDots: $('.js-cs-slider-dots'),
            });
        }

    }

};

new CaseStudiesSlider();